import { render } from "./burgerMenu.vue?vue&type=template&id=49a258f0&ts=true"
import script from "./burgerMenu.vue?vue&type=script&lang=ts"
export * from "./burgerMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__